import {ProductInCatalog} from '@treez/commons/sharedTypings/product';
import {ProductFormSection} from '~/modules/forms/ProductForm';

export enum ProductFormAction {
    OPEN_PRODUCT_INSPECTOR_ONLY = 'OPEN_PRODUCT_INSPECTOR',
    OPEN_PRODUCT_FORM_ONLY = 'OPEN_PRODUCT_FORM',
    OPEN_INSPECTOR_AND_FORM = 'OPEN_INSPECTOR_AND_FORM',
    SET_PRODUCT_TO_INSPECT = 'SET_PRODUCT_TO_INSPECT',
    CLOSE_PRODUCT_FORM_ONLY = 'CLOSE_PRODUCT_FORM',
    CLOSE_ALL = 'CLOSE_ALL',
}

export interface ProductFormState {
    productToInspect?: ProductInCatalog;
    isInspectorOpen: boolean;
    isProductFormOpen: boolean;
    scrollTo: ProductFormSection | null;
}

const {
    OPEN_PRODUCT_INSPECTOR_ONLY,
    OPEN_INSPECTOR_AND_FORM,
    OPEN_PRODUCT_FORM_ONLY,
    SET_PRODUCT_TO_INSPECT,
    CLOSE_PRODUCT_FORM_ONLY,
    CLOSE_ALL,
} = ProductFormAction;

export const openProductInspectorOnly = (productToInspect: ProductInCatalog) => {
    return {
        type: OPEN_PRODUCT_INSPECTOR_ONLY,
        productFormState: {
            productToInspect,
            isInspectorOpen: true,
        },
    };
};

export const openProductInspectorAndForm = (
    productToInspect: ProductInCatalog,
    scrollTo?: ProductFormSection
) => {
    return {
        type: OPEN_INSPECTOR_AND_FORM,
        productFormState: {
            productToInspect,
            scrollTo,
            isInspectorOpen: true,
            isProductFormOpen: true,
        },
    };
};

export const openProductFormOnly = (
    productToInspect?: ProductInCatalog,
    scrollTo?: ProductFormSection
) => {
    return {
        type: OPEN_PRODUCT_FORM_ONLY,
        productFormState: {
            productToInspect,
            scrollTo,
            isProductFormOpen: true,
        },
    };
};

export const setProductToInspect = (productToInspect: ProductInCatalog) => {
    return {
        type: SET_PRODUCT_TO_INSPECT,
        productFormState: {productToInspect},
    };
};

export const closeProductFormOnly = () => {
    return {
        type: CLOSE_PRODUCT_FORM_ONLY,
        productFormState: {
            isProductFormOpen: false,
        },
    };
};

export const closeProductFormAndInspector = () => {
    return {
        type: CLOSE_ALL,
        productFormState: {
            productToInspect: undefined,
            isInspectorOpen: false,
            isProductFormOpen: false,
        },
    };
};
